// extracted by mini-css-extract-plugin
module.exports = {"title":"basic-module--title--2Ge3i","body":"basic-module--body--2BezL"};